import { AccessChangesTable } from './access-changes-table';
import { AccessLogTable } from './access-log-table/AccessLogTable';
import { AccessStatistics } from './access-statistics/AccessStatistics';
import { ApiVolumeGraph } from './api-volume/ApiVolumeGraph';
import { ApplicationOverview } from './application-overview';
import { AppStatusTable } from './application-status';
import { BlockedApplicationAlert } from './BlockedApplicationAlert';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityViewContainer } from './DataSecurityViewContainer';
import { DataSecurityViewQueryParams } from './DataSecurityView';
import { IncidentLogTable } from './incident-log-table';
import React from 'react';
import { UptimeMonitorsDashboard } from './uptime-monitors-dashboard';
import { useParams } from 'react-router-dom';
import { VerticalColumn } from '@ui/general/VerticalColumn';

export interface DataSecurityApplicationOverviewProps {
	viewParams: DataSecurityViewQueryParams;
	onViewChange: (params: DataSecurityViewQueryParams) => void;
}

export const DataSecurityApplicationOverview: React.FC<DataSecurityApplicationOverviewProps> = ({
	viewParams,
	onViewChange
}) => {
	const { id } = useParams<{id: string}>();

	const applicationId = Number(id);

	return (
		<DataSecurityViewContainer
			onViewChange={ onViewChange }
			title={ COPY_SPECIFIC.APPLICATION_OVERVIEW }
			viewParams={ viewParams }>
			<BlockedApplicationAlert
				applicationId={ applicationId }
				dashboard />
			<VerticalColumn>
				<UptimeMonitorsDashboard applicationId={ applicationId } />
				<ApplicationOverview applicationId={ applicationId } />
				<AccessLogTable
					applicationId={ applicationId }
					dateRange={ viewParams.dateRange } />
			</VerticalColumn>
			<VerticalColumn>
				<ApiVolumeGraph
					applicationId={ applicationId }
					viewParams={ viewParams } />
				<AccessStatistics
					applicationId={ applicationId }
					viewParams={ viewParams } />
				<AccessChangesTable
					applicationId={ applicationId }
					viewParams={ viewParams } />
				<div className='column-row'>
					<AppStatusTable applicationId={ applicationId } />
					<IncidentLogTable
						applicationId={ applicationId }
						viewParams={ viewParams } />
				</div>
			</VerticalColumn>
		</DataSecurityViewContainer>
	);
};
